module.exports = __webpack_public_path__ + "static/media/calendar.daccf1ec.svg";